import React, {useState} from "react";

// reactstrap components
import {
  Row,
  Col,
} from "reactstrap";

import {
    PieChartDiv,
    HeaderLegend,
    ChartsArea,
    PieChartPayments,
    BarChartDiv,
    Ratings,
    ButtonTab,
    PieChartPromotion,
    PieChartDivPromotion
  } from './styles';

import LineChart from '../Reports/LineChart'
import RadarChart from '../Reports/RadarChart';
import PieChart from '../Reports/PieChart';
import BarChart from '../Reports/BarChart';

function PromotionsReport({promotion}) {
    console.log('promotion', promotion);
    return (
      <>
        <Row style={{paddingTop: 20}}>
                <Col md="8">
                  <Row>
                    <Col md="3">
                      <img
                          alt="..."
                          src={promotion.promotion && promotion.promotion.avatar ? promotion.promotion.avatar.url : null}
                          style={{width: 120, height: 120, borderRadius: '50%'}}
                      />
                    </Col>
                    <Col md="8" style={{textAlign: 'left'}}>
                      <div style={{display: 'flex', flexDirection: 'row'}}>
                        {promotion.ranking === 1 ? <>
                        <h2 style={{fontSize: 25}}>
                          <i className="nc-icon nc-trophy" style={{color: '#CC8F00'}}/> 
                        </h2>
                        <h2 style={{fontSize: 28, marginLeft: 15, color: '#CC8F00'}}>
                          1º.
                        </h2>
                        </> : 
                        <>
                            <h2 style={{fontSize: 28,}}>
                            {promotion.ranking}º.
                            </h2>
                        </>}
                        <h2 style={{fontSize: 25, marginLeft: 5}}>
                          {promotion.promotion && promotion.promotion.name}
                        </h2>
                      </div>
                      
                      {promotion.ranking === 1 &&
                        <p style={{color: '#CC8F00', marginTop: -30}}>
                            Essa é sua oferta mais resgatada!
                        </p>
                      }

                      <div style={{display: 'flex', flexDirection: 'row'}}>
                        <h2 style={{color: ''}}>
                          {promotion.count}
                        </h2>
                        <p style={{ marginLeft: 5, marginTop: 18}}>resgates</p>
                      </div>

                      <p style={{marginTop: -30}}>
                        Essa oferta representa {promotion.percent}% dos resgates de sua loja.
                      </p>
                      
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <PieChartDivPromotion>
                        <LineChart
                          data={{
                            labels: promotion.monthData,
                            datasets: [
                              {
                                label: 'Resgates',
                                data: promotion.rescueData,
                                backgroundColor: 'blue',
                                borderColor: 'blue',
                                borderWidth: 1,
                                tension: 0.4,
                              },
                            ],
                          }}
                        />
                      </PieChartDivPromotion>
                    </Col>
                  </Row>
                </Col>
                
                <Col md="4">
                  <PieChartPromotion style={{marginTop: 10}}>
                    <PieChart
                      style={{
                        heigth: 300
                      }}
                      data={{
                        labels: ['Masculino', 'Feminino', 'Outros'],
                        datasets: [
                          {
                            data: promotion.gender,
                            backgroundColor: ['#3B8EA5', '#e83e8c', '#B60AFF'],
                            tension: 0.4,
                          }
                        ],
                      }}
                    />
                    <div style={promotion.styleGender}>
                        <p style={{textAlign: 'center'}}>{promotion.percentGender}% {promotion.phraseGender}</p>
                    </div>
                  </PieChartPromotion>
                  </Col>
              </Row>
              <Row>
              <Col md="6">
                  <PieChartDiv >
                    <HeaderLegend>Bairros</HeaderLegend>
                    <RadarChart
                      data={{
                        labels: promotion.bairrosLabel,
                        datasets: [
                          {
                            label: 'Clientes',
                            data: promotion.bairrosData,
                            backgroundColor: '#007C7750',
                            borderColor: '#007C77',
                            borderWidth: 1,
                            fill: true
                          },
                        ],
                      }}
                    />
                  </PieChartDiv>
                </Col>
                  <Col md="6">
                    <BarChartDiv style={{marginTop: 10}}>
                      <HeaderLegend>Idade do Público dessa Oferta</HeaderLegend>
                      <BarChart
                        data={{
                          labels: ['0 - 9', '10 - 19', '20 - 29', '30 - 39', '40 - 49', '50 - 59', '60 - 69', '70 - 79', '80 - 89', '90 - 99'],
                          datasets: [
                            {
                              label: 'Quantidade de Clientes',
                              backgroundColor: [
                              '#2a778e',
                              '#009684',
                              '#226666',
                              '#669999',
                              '#407F7F',
                              '#0D4D4D',
                              '#003333',
                              '#27556C',
                              '#6E91A1',
                              '#477286'],
                              data: promotion.ages,
                              tension: 0.4,
                            }
                          ],
                        }}
                      />
                      </BarChartDiv>
                </Col>
            </Row>
            <Row>
                <Col>
                  <div style={{borderBottom: '2px solid #D9D6D4', marginTop: 30}}>
                  </div>        
                </Col>
            </Row>
        </>
    );
}

export default PromotionsReport;
